/**
 * Config Firebase de Gojob Radio.
 *
 * Ces valeurs sont **publiques par design** : elles finissent dans le bundle servi
 * au navigateur, quel que soit le moyen de les y mettre. La sécurité tient aux
 * règles Firestore et à la validation du token côté API — jamais à leur secret.
 *
 * Elles sont écrites ici plutôt que dans un `.env.production` parce que le
 * monorepo ignore ce nom de fichier (règle racine du `.gitignore`) : le CI ne le
 * verrait pas, et produirait un SPA incapable de se connecter. Un fichier source
 * versionné rend le build reproductible partout.
 *
 * Les surcharges par variable d'environnement restent possibles pour du dev
 * pointant sur un autre projet.
 */
const env = import.meta.env;

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY ?? "AIzaSyAR2bk397gzdqMTYqDIaRnTA6fjIJN9wNY",
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? "gojob-vibe-coding.firebaseapp.com",
  projectId: env.VITE_FIREBASE_PROJECT_ID ?? "gojob-vibe-coding",
  appId: env.VITE_FIREBASE_APP_ID ?? "1:283063775731:web:c4ce66892821554a86e286",
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "283063775731",
} as const;

/** Base Firestore *nommée* : le projet héberge d'autres apps sur la base par défaut. */
export const firestoreDatabase = env.VITE_FIRESTORE_DATABASE ?? "gojob-radio";

/** Domaine dont les comptes Google sont acceptés. */
export const allowedDomain = "gojob.com";
